<template>
  <main :class="$helper.isProxyLoggedIn() ? 'lastEvPg mt-[0px]' : 'lastEvPg mt-[60px]'" >
    <div class="container container-mini">
      <div>
        <div class="heading d-flex align-items-center justify-content-between">
          <h4 class="blackText fw-bold pt-4 mb-4">
            <b>{{ 'Last Evaluation ' }}</b><br>
            <b v-if="previousEvaluation">{{ `(${previousEvaluation?.last_evaluation_date}) - Job ID ` }}
            </b>
            <b v-else>{{ ` Job ID ` }} </b>
            <span v-if="previousEvaluation" class="orangeText">{{ `${previousEvaluation?.booking_id}` }}</span>
          </h4>
          <nest_notes_modal />
        </div>
        <div class="breadcrumbs border rounded p-2 mb-4">
          <ul class="d-flex list-inline mb-0">
            <li>
              <a :href="'/job/detail/' + jobId" class="greyText">Job Details</a>
            </li>
            <li>
              <a :href="'/select/unit/' + jobId" class="greyText">Units</a>
            </li>
            <li v-if="previousEvaluation" class="blueText">
              Last Evaluation - Job ID {{ `${previousEvaluation?.booking_id}` }}
            </li>
          </ul>
        </div>
      </div>

      <div class="outdorrEquipSec">
        <div class="outdorrEquipHead d-flex align-items-center justify-content-between my-4">
          <h5 v-if="previousEvaluation" class="blueText mb-0">
            {{ previousEvaluation?.unit_name }}
          </h5>
          <ul class="list-inline mb-0 d-flex">
            <li class="me-2 d-flex align-items-center">
              <img src="../../assets/images/duck-head-icon.png" class="me-2" alt="yellow-icon">
              <p class="mb-0">
                Not operating as per manufacturer's specification
              </p>
            </li>
            <li class="me-2 d-flex align-items-center">
              <img src="../../assets/images/electric-head-icon.png" class="me-2" alt="red-icon">
              <p class="mb-0">
                Non Operation / Critical
              </p>
            </li>
          </ul>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <div id="outdoorSec" class="section outdoorUnit">
              <div class="row">
                <div v-for="(item, index) in options" :key="index" class="col-lg-3 col-md-3">
                  <selectableItem :item="item" :isSelected="selectedItems.some(i => i.id === item.id)"
                    @update:selected="val => toggleSelect(item, val)" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="buttons d-flex justify-content-center mt-5">
        <button class="btn buttonDark rounded me-2" @click="backButtonClicked()">
          Back
        </button>

        <button class="btn buttonPrimary rounded me-2 flex items-center gap-2" @click="reEvaluateClicked()"
          style="display: flex; gap: 10; align-items: center;">
          <img src="../../assets/images/evaluate-icon.png" class="me-2" alt="">Re-Evaluate this system
        </button>

        <button class="btn buttonSecondary rounded flex items-center gap-2" @click="continueClicked()"
          style="display: flex; gap: 10; align-items: center;" :disabled="selectedItems?.length < 1">
          <img src="../../assets/images/add-circle.png" class="me-2" alt="">Continue using selected items
        </button>
      </div>
    </div>
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import nest_notes_modal from "../../components/nest_components/nest_notes_modal.vue";
import { useToast } from "vue-toastification";
import selectableItem from "../../components/nest_components/selectableItem.vue";
const toast = useToast();

export default {
  components: {
    nest_notes_modal,
    selectableItem
  },

  data() {
    return {
      jobId: this.$route.params.id,
      unit_id: this.$route.query.unit_id,
      options: [],
      selectedItems: [],
      isReEvaluate: false
    };
  },


  computed: {
    ...mapGetters([
      "previousEvaluation",
      "bookingResponse",
      "previousEvaluationResponse",
      "storeChecksResponse",
      "getDiagnosisOptions"
    ]),
  },


  watch: {
    bookingResponse: function () {
      if (this.bookingResponse !== null) {
        this.getDiagnosisOption({
          booking_id: this.jobId,
          diagnosis_type: "last_evaluation",
        });
      }
    },

    previousEvaluation: function () {
      this.options = this.previousEvaluation.options

    },

    getDiagnosisOptions: function () {
      if (!this.$helper.isEmpty(this.getDiagnosisOptions)){
        this.selectedItems = JSON.parse(this.getDiagnosisOptions[0]?.diagnosis_data)
      }
      this.getPreviousEvaluation({
        booking_id: this.jobId,
        unit_id: this.unit_id,
      });
    },

    storeChecksResponse: function () {
      this.postPreviousEvaluation({
        booking_id: this.jobId,
        options: JSON.stringify(this.isReEvaluate ? [] : this.selectedItems)
      });
    },

    previousEvaluationResponse: function () {
      if (this.previousEvaluationResponse) {
        this.$router.push({
          path: `/equipment/${this.$route.params.id}`,
          query: {
            unit_id: this.unit_id,
            is_from_mobile: this.$route.query.is_from_mobile,
          },
        });
      }
    },
  },

  mounted() {
    this.getBookingDetails({
      booking_id: this.jobId,
    });
    window.addEventListener("scroll", this.updateOffset);
  },

  methods: {
    ...mapActions([
      "getPreviousEvaluation",
      "getBookingDetails",
      "postPreviousEvaluation",
      "getDiagnosisOption",
      "storeChecks"
    ]),

    updateOffset() {
    },

    backButtonClicked() {
      this.$router.go(-1);
    },

    reEvaluateClicked() {
      this.isReEvaluate = true
      this.storeChecks({
        booking_id: this.jobId,
        diagnosis_type: "last_evaluation",
        diagnosis_data: JSON.stringify([]),
      });
    },

    continueClicked() {
      if (this.selectedItems?.length > 0) {
        this.isReEvaluate = false
        this.storeChecks({
          booking_id: this.jobId,
          diagnosis_type: "last_evaluation",
          diagnosis_data: JSON.stringify(this.selectedItems),
        });
      } else {
        toast.error("Please select at least one item.");
      }
    },

    toggleSelect(item, val) {
      if (val) {
        this.selectedItems.push(item);
      } else {
        this.selectedItems = this.selectedItems.filter(i => i.id !== item.id);
      }
    }
  },
};
</script>

<style>
.heading br {
  display: none;
}

.heading a img {
  width: 40px;
}

.highlight {
  border: 2px solid red;
  padding: 10px;
}

.minHeight {
  min-height: 0px;
}


.lastEvPg .form-group .customRadiocheck [type="radio"]:checked+label:before,
.lastEvPg .form-group .customRadiocheck [type="radio"]:not(:checked)+label:before {
  right: 5px;
  top: -20px;
}

.lastEvPg .form-group [type="radio"]:checked+label:after,
.lastEvPg .form-group [type="radio"]:not(:checked)+label:after {
  top: -14px;
  right: 10px;
}

@media screen and (max-width: 575px) {
  .heading br {
    display: block;
  }
}
</style>
